import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../../map/utils/mapFunctions';
import { ObstacleExact } from '../../../../../mission/models/Obstacle';

const ObstacleTreeView = ({ obstacles, setObstacles, setCenteredGeometries, disabled }) => {
  const handleObstaclesCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(obstacles, item.id));
    },
    [obstacles, setCenteredGeometries]
  );

  const handleObstaclesVisibilityClick = useCallback(
    (item, isToggled) => {
      setObstacles((oldObstacles) => getEntitiesWithVisibility(oldObstacles, item.id, isToggled));
    },
    [setObstacles]
  );

  const { current: obstacleItemActions } = useRef([
    { id: 'obstacle-center', icons: { default: 'gps_fixed' }, onClick: handleObstaclesCenterClick },
    {
      id: 'obstacle-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleObstaclesVisibilityClick,
    },
  ]);

  const obstacleItems = useMemo(
    () => [
      {
        id: 'root',
        label: `${i18n.t('patrol.details.obstacles')}: ${obstacles.length}`,
        actions: obstacleItemActions,
        disabled,
      },
    ],
    [disabled, obstacleItemActions, obstacles.length]
  );

  return <TreeView id="obstacles" items={obstacleItems} initialToggleActions={{ 'obstacle-visibility': true }} />;
};

ObstacleTreeView.propTypes = {
  obstacles: PropTypes.arrayOf(ObstacleExact),
  setObstacles: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ObstacleTreeView.defaultProps = {
  obstacles: [],
  disabled: false,
};

export default ObstacleTreeView;
